/* eslint-disable default-param-last */
import { actions, types } from './actions'

const initialState: AmbassadorState = {
    currentIndex: 0,
    challengeCurrentIndex: 0,
    selectedChallengeIndex: -1,
    afterSocialShareUrl: '',
}

export const reducer = (state: AmbassadorState = initialState, action: ActionsUnion<typeof actions>): AmbassadorState => {
    switch (action.type) {
        case types.ASSIGN_AMBASSADOR_SETTINGS:
            // eslint-disable-next-line no-case-declarations
            const payload = action.payload
            const result = {
                ...state,
                instanceSettings: payload as AmbassadorSettingsDto,
            }
            return result
        case types.POPULATE_AMBASSADOR_DATA:
            return {
                ...state,
                data: action.payload as InitiativeDataRecord[],
            }
        case types.POPULATE_AMBASSADOR_CHALLENGE:
            return {
                ...state,
                challengeData: action.payload as ChallengeDataRecord[],
            }
        case types.POPULATE_CURRENT_INDEX:
            return {
                ...state,
                currentIndex: action.payload as number,
            }
        case types.TOGGLE_MODAL:
            return {
                ...state,
                showModal: !state.showModal,
            }
        case types.POPULATE_CHALLENGE_CURRENT_INDEX:
            return {
                ...state,
                challengeCurrentIndex: action.payload as number,
            }
        case types.POPULATE_AFTER_SOCIAL_SHARE_URL:
            return {
                ...state,
                afterSocialShareUrl: action.payload as string,
            }
        case types.POPULATE_SELECTED_CHALLENGE_INDEX:
            return {
                ...state,
                selectedChallengeIndex: action.payload as number,
            }
        case types.ON_AMBASSADOR_PROFILE:
            return {
                ...state,
                onAmbassadorProfile: action.payload as boolean,
            }
        case types.POPULATE_AMBASSADOR_PROFILE:
            return {
                ...state,
                ambassadorProfile: action.payload as AmbassadorProfileRecord,
            }
        default:
            return state
    }
}
